import PropTypes from 'prop-types';
import { Theme } from '@spoiler-alert/ui-library';
import { subscriptionTiers } from '../../../utilities';

export const siteProp = PropTypes.shape({
  _id: PropTypes.string,
  siteName: PropTypes.string,
  siteRole: PropTypes.arrayOf(PropTypes.string),
  siteType: PropTypes.string,
  itemImportSite: PropTypes.string,
  physicalAddress: PropTypes.shape({
    content: PropTypes.string,
    loc: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    city: PropTypes.string,
    streetAddress: PropTypes.string,
    stateCode: PropTypes.string,
    zipCode: PropTypes.string,
    countryCode: PropTypes.string,
  }),
  archived: PropTypes.bool,
  subscriptionTier: PropTypes.oneOf(subscriptionTiers),
  parentSite: PropTypes.string,
  transactionServicesSettings: PropTypes.shape({
    supportedLogisticsOptions: PropTypes.arrayOf(PropTypes.oneOf(['DELIVERY', 'PICKUP'])),
    paymentTerms: PropTypes.string,
    pickupLeadTime: PropTypes.string,
    channelRestrictions: PropTypes.string,
    packingListContacts: PropTypes.arrayOf(PropTypes.string),
    takeRate: PropTypes.string,
    supplierPaymentDueDays: PropTypes.string,
    buyerPaymentDueDays: PropTypes.string,
  }),
});

export const propTypes = {
  site: siteProp,
  setFieldValue: PropTypes.func,
  orgSite: siteProp,
};

export const siteRoles = { BUYER: 'BUYER', SELLER: 'SELLER' };

export const siteTypes = { ORGANIZATION: 'ORGANIZATION', FACILITY: 'FACILITY', BUSINESS_UNIT: 'BUSINESS_UNIT' };

export const logisticsOptions = {
  PICKUP: 'Pickup',
  DELIVERY: 'Delivery',
};

export const styles = {
  box: {
    padding: 30,
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    flexWrap: 'wrap',
    '&>*': {
      width: '100%',
    },
  },
  formbox: {
    extend: 'box',
    padding: 0,
    maxWidth: 600,
    '& h4': {
      margin: 0,
      fontWeight: 400,
    },
  },
  mapContainer: {
    width: '100%',
    height: 400,
    border: `2px solid ${Theme.greyDark}`,
    overflow: 'hidden',
  },
  half: {
    width: 'calc(50% - 10px)',
  },
  halfWrap: {
    extend: 'half',
    display: 'flex',
    gap: 20,
  },
  buttons: {
    display: 'flex',
    gap: 15,
  },
  header: {
    padding: [10, 15],
    display: 'flex',
    gap: 15,
    alignItems: 'center',
  },
  headerRight: {
    marginLeft: 'auto',
    display: 'flex',
    gap: 15,
    alignItems: 'center',
  },
  search: {
    margin: 10,
  },
  vtable: {
    border: `1px solid ${Theme.grey10}`,
  },
  modalHeading: {
    margin: 0,
  },
  modalContent: {
    textAlign: 'left',
    padding: 20,
    width: '100%',
  },
  modalFooter: {
    display: 'flex',
    gap: 20,
    flexDirection: 'row-reverse',
    paddingTop: 20,
    borderTop: `1px solid ${Theme.grey10}`,
    marginTop: 20,
  },
  newEmail: {
    display: 'flex',
    gap: 15,
    alignItems: 'center',
  },
  emailPills: {
    display: 'flex',
    gap: 10,
    margin: [10, 0],
    '&>*': {
      padding: [5, 8],
      fontSize: 10,
    },
  },
  emailBox: {
    border: `2px solid ${Theme.grey10}`,
    padding: 15,
  },
};
